import { useQuery } from '@tanstack/react-query';

import { getChannelMarkupV2ById } from '~/services/PromoService';

export const channelMarkupV2QueryKeys = {
  all: ['channel-markup-v2'] as const,
  details: () => [...channelMarkupV2QueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...channelMarkupV2QueryKeys.details(), id] as const,
  checks: () => [...channelMarkupV2QueryKeys.all, 'check'] as const,
  check: (payload: unknown) => [...channelMarkupV2QueryKeys.checks(), payload] as const,
};

type Params = {
  channelMarkupId?: string | null;
  enabled?: boolean;
};

export function useGetChannelMarkupV2ById({ channelMarkupId, enabled = true }: Params) {
  return useQuery({
    queryKey: channelMarkupV2QueryKeys.detail(channelMarkupId ?? ''),
    queryFn: async () => {
      const response = await getChannelMarkupV2ById(channelMarkupId);
      return response.result;
    },
    enabled: enabled && !!channelMarkupId,
    // Always pull fresh server data on mount so edits made elsewhere (or a save + reopen
    // within the global staleTime window) are reflected immediately.
    refetchOnMount: 'always',
  });
}
